import React, { useState } from 'react';
import Layout from '../components/Layout';
import data from '../data/data.json';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';

const Daftar = () => {
  const [name, setName] = useState('');
  const [sex, setSex] = useState('');
  const [birth, setBirth] = useState('');
  const [address, setAddress] = useState('');
  const [phone, setPhone] = useState('');
  const [hafalan, setHafalan] = useState('');

  const sendToWhatsApp = () => {
    const adminNumber = '6281233487147';
    const message = `Halo Admin, saya ingin mendaftar:\n\nNama: ${name}\nJenis Kelamin: ${sex}\nTTL: ${birth}\nAlamat: ${address}\nNomor Telepon: ${phone}\nJumlah Hafalan: ${hafalan}`;
    const whatsappURL = `https://wa.me/${adminNumber}?text=${encodeURIComponent(message)}`;

    window.open(whatsappURL, '_blank');
  };

  return (
    <Layout>
      <section>
        <div className='flex flex-col gap-1 justify-center items-center p-4 text-white'>
          <h2 className='text-2xl lg:text-3xl font-bold text-yellow-400'>Pendaftaran Santri Baru</h2>
          <h1 className='text-3xl lg:text-4xl text-cyan-600'>Rumah Tahfidz An-Nuur</h1>
        </div>
        <div className='flex flex-col gap-3 lg:gap-4 px-5 md:px-20 lg:px-40 font-inter text-white'>
          <p className='lg:text-xl '>Selamat datang di halaman pendaftaran Rumah Tahfidz An-Nuur! Kami dengan bangga menawarkan program pembelajaran tahfidz yang mendidik dan menyenangkan, bertujuan untuk membimbing generasi muda dalam menghafal Al-Qur'an dengan baik.</p>
          <p className='lg:text-xl text-center font-semibold'>Mengapa Rumah Tahfidz An-Nuur?</p>
          <div className='flex flex-col lg:grid lg:grid-cols-2 gap-3 p-1 lg:p-16 md:px-20 lg:px-28'>
            {data.fasilitas.map((fasilitas, index) => (
              <div className='bg-blur p-6 shadow-2xl rounded-3xl' data-aos='zoom-in-up'>
                <div key={index} className='flex flex-col justify-center items-center gap-3'>
                  <h1 className='text-center text-xl md:text-2xl lg:text-3xl font-bold'>{fasilitas.fasilitas}</h1>
                  <p className='text-center md:text-base lg:text-xl mb-4'>{fasilitas.deskripsi}</p>
                </div>
              </div>
            ))}
          </div>
          <p className='text-center text-xl lg:text-3xl font-semibold mt-4'>Brosur & Cara Mendaftar</p>
          <div className='flex justify-center items-center'>
            <img src='brosur.jpeg' alt='brosur' className='w-full  md:max-w-md lg:max-w-lg xl:max-w-xl' data-aos='fade-up'/>
          </div>
          <p className='lg:text-lg lg:text-center lg:px-20'>Untuk mendaftar sebagai santri baru, silakan mengisi formulir pendaftaran di bawah ini. 
          Pastikan setiap informasi yang Anda masukkan benar dan lengkap agar proses pendaftaran berjalan lancar.</p>
        </div>
      </section>

      <section id='form'>
        <div className="flex flex-col items-center justify-center p-4">
          <h2 className="text-2xl lg:text-3xl text-white font-bold py-4">Form Pendaftaran</h2>
          <div className="w-full max-w-md lg:max-w-screen-md bg-yellow-400 p-8 rounded-lg shadow-2xl" data-aos='fade-up'>
            <label className="block mb-4">
              <span className="text-gray-700">Nama Lengkap:</span>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="mt-1 block w-full px-4 py-2 border text-white bg-yellow-800 border-white rounded-md focus:outline-none focus:ring-2 focus:ring-white placeholder-gray-200"
                placeholder="Masukkan nama lengkap"
                required
              />
            </label>
            <label className="block mb-4">
              <span className="text-gray-700">Jenis Kelamin:</span>
              <select
                value={sex}
                onChange={(e) => setSex(e.target.value)}
                className="mt-1 block w-full px-4 py-2 border text-white bg-yellow-800 border-white rounded-md focus:outline-none focus:ring-2 focus:ring-white placeholder-gray-200"
                required
              >
                <option value="">Pilih jenis kelamin</option>
                <option value="Laki-laki">Laki-laki</option>
                <option value="Perempuan">Perempuan</option>
              </select>
            </label>
            <label className="block mb-4">
              <span className="text-gray-700">Tempat, Tanggal Lahir (TTL):</span>
              <input
                type="text"
                value={birth}
                onChange={(e) => setBirth(e.target.value)}
                className="mt-1 block w-full px-4 py-2 border text-white bg-yellow-800 border-white rounded-md focus:outline-none focus:ring-2 focus:ring-white placeholder-gray-200"
                placeholder="Contoh (Jakarta, 1 Juni 2003)"
                required
              />
            </label>
            <label className="block mb-4">
              <span className="text-gray-700">Alamat Lengkap:</span>
              <textarea
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                className="mt-1 block w-full px-4 py-2 border text-white bg-yellow-800 border-white rounded-md focus:outline-none focus:ring-2 focus:ring-white placeholder-gray-200"
                placeholder="Masukkan alamat lengkap"
                required
              />
            </label>
            <label className="block mb-4">
              <span className="text-gray-700">Nomor Telepon:</span>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="mt-1 block w-full px-4 py-2 border text-white bg-yellow-800 border-white rounded-md focus:outline-none focus:ring-2 focus:ring-white placeholder-gray-200"
                placeholder="Masukkan nomor telepon"
                required
              />
            </label>
            <label className="block mb-4">
              <span className="text-gray-700">Jumlah Hafalan (Opsional):</span>
              <input
                type="text"
                value={hafalan}
                onChange={(e) => setHafalan(e.target.value)}
                className="mt-1 block w-full px-4 py-2 border text-white bg-yellow-800 border-white rounded-md focus:outline-none focus:ring-2 focus:ring-white placeholder-gray-200"
                placeholder="Jika ada, sudah berapa juz"
              />
            </label>
            <button
              onClick={sendToWhatsApp}
              className="w-full bg-green-500 text-white py-2 px-4 rounded-md font-semibold hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500"
            >
              Daftar via WhatsApp
            </button>
          </div>
        </div>
      </section>

      <section>
        <div className='flex flex-col p-4 md:px-20 justify-center items-center gap-2 text-white'>
          <h1 className='text-2xl'>Informasi Kontak</h1>
          <p>Jika Anda memiliki pertanyaan atau memerlukan informasi lebih lanjut, jangan ragu untuk menghubungi kami. Kami siap membantu!</p>
          <p>Hubungi Kami :</p>
          <p><FontAwesomeIcon icon={faPhone} className='mr-2'/>WhatsApp : <a href='https://wa.me/6281233487147' className='hover:text-yellow-500'>(+62) 812-3348-7147</a></p>
          <p>Lokasi : </p>
          <p className='text-center'><FontAwesomeIcon icon={faLocationDot} className='mr-2' />Jl. Tanjakan Sa'ar, RT.004/RW.004, Jatiluhur, Kec. Jatiasih, Kota Bks, Jawa Barat 17425</p>
        </div>

        <div class="w-full p-4 md:px-20 lg:px-44">
          <iframe
              class="w-full h-[300px] rounded-xl border-0"
              scrolling="no"
              title="Peta Rumah Tahfidz An-Nur"
              loading='lazy'
              src="https://maps.google.com/maps?width=100%25&amp;height=400&amp;hl=en&amp;q=MWMR+QX2,%20Jl.%20Tanjakan%20Sa'ar,%20RT.004/RW.004,%20Jatiluhur,%20Kec.%20Jatiasih,%20Kota%20Bks,%20Jawa%20Barat%2017425+(Rumah%20Tahfidz%20An-Nur)&amp;t=p&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed">
          </iframe>
        </div>
      </section>
    </Layout>
  );
};

export default Daftar;